import { createFileRoute } from "@tanstack/react-router";
import StatisticiAuto from "@/pages/StatisticiAuto";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/statistici-auto-romania/")({
  head: () => routeHead("/statistici-auto-romania/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <StatisticiAuto />
  );
}
